// ECharts的通用类
// 关键点：
// 1.useRef + init  避免重复初始化，提升性能
// 2.dispose() 防止内存泄漏，组件卸载时清理
// 3.window.addEventListener('resize') 自动响应容器大小变化
// 4.loading 状态 支持异步数据加载提示
// 5.setOption(option, true) true表示强制刷新，避免部分更新失效

import React, { useRef, useEffect } from 'react';
import * as echarts from 'echarts';

const EChartsReact = ({ option, style = {}, className = '', loading = false }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    // 初始化或更新图表
    useEffect(() => {
        if (!chartRef.current) return;

        // 如果已存在实例，先销毁避免内存泄漏
        if (chartInstance.current) {
            chartInstance.current.dispose();
        }

        // 创建新实例
        chartInstance.current = echarts.init(chartRef.current);

        // 设置选项
        if (option) {
            chartInstance.current.setOption(option, true);
        }

        // 响应窗口大小变化
        const handleResize = () => {
            chartInstance.current.resize();
        };

        window.addEventListener('resize', handleResize);

        // 清理函数：组件卸载时销毁实例
        return () => {
            window.removeEventListener('resize', handleResize);
            if (chartInstance.current) {
                chartInstance.current.dispose();
                chartInstance.current = null;
            }
        };
    }, [option]); // 只有 option 变化时才更新

    // 加载状态处理
    if (loading) {
        return (
            <div
                ref={chartRef}
                style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}
            >
                正在加载中...
            </div>
        );
    }

    return (
        <div
            ref={chartRef}
            className={className}
            style={{ width: '100%', height: '100%', ...style }}
        />
    );
};

export default EChartsReact;
